// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3LlZX","head":"Table_head__2RSco","col":"Table_col__1Xiyj"};